import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import "./categoryForm.css";

const CategoryForm = ({ open, onClose, onSubmit, category, franchiseId }) => {
  const [formState, setFormState] = useState({
    categoryName: "",
    isHomeListed: false,
    icon: null,
  });

  useEffect(() => {
    if (category) {
      console.log(category.icon)
      setFormState({
        categoryName: category.category_name,
        isHomeListed: category.is_home_listed ?? false,
        icon: category.icon,
      });
    } else {
      setFormState({
        categoryName: "",
        isHomeListed: false,
        icon: null,
      });
    }
  }, [category]);

  const [errors, setErrors] = useState({});

  const validationForm = () => {
    const newErrors = {};
    if (!formState.categoryName)
      newErrors.categoryName = "Category is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState({
      ...formState,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleFileChange = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      icon: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validationForm()) {
      const updatedData = {
        category_name: formState.categoryName,
        is_home_listed: formState.isHomeListed,
        icon: formState.icon,
        business: franchiseId,
      };
      onSubmit(updatedData);
      setFormState({
        categoryName: "",
        isHomeListed: false,
        icon: null,
      });
      onClose();
    }
  };

  const handleClose = () => {
    setFormState({
      categoryName: "",
      isHomeListed: false,
      icon: null,
    });
    onClose();
  };
  

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ color: "#ff4d4d" }}>
        {category ? "Edit Category" : "Add Category"}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Category"
          name="categoryName"
          margin="dense"
          value={formState.categoryName}
          onChange={handleChange}
          error={!!errors.categoryName}
          helperText={errors.categoryName}
        />
        <div className="prev-container">
          <label htmlFor="file-upload" className="custom-file-upload">
            Category Icon
          </label>

          <input
            className="image-upload"
            id="file-upload"
            type="file"
            name="icon"
            onChange={handleFileChange}
          />
          {formState.icon && formState.icon instanceof File && (
            <img
              className="thumb-img"
              src={URL.createObjectURL(formState.icon)}
              alt="Preview"
            />
          )}
        </div>
        <br />
        <FormControlLabel
          control={
            <Checkbox
              name="isHomeListed"
              checked={formState.isHomeListed}
              onChange={handleChange}
            />
          }
          label="Is Home Listed"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          style={{ textTransform: "none" }}
        >
          {category ? "save" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryForm;
